import React, { useState } from 'react';
import { UserCog, RefreshCw } from 'lucide-react';
import UserManagementView from './UserManagementView';
import LeaveTypeCorrectionView from './LeaveTypeCorrectionView';

const AdminToolsView = ({ currentUser, departments, holidays, onReloadUsers }) => {
  const [subTab, setSubTab] = useState('users');

  return (
    <div className="max-w-6xl mx-auto space-y-6 min-h-[80vh]">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="bg-blue-600 dark:bg-jewel-teal p-2 rounded-xl shadow-lg shadow-blue-200 dark:shadow-jewel-teal/30">
            <UserCog className="h-6 w-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-black text-gray-900 dark:text-jewel-text leading-tight">
              Διαχείριση
            </h2>
            <p className="text-sm text-gray-500 dark:text-jewel-text-muted font-medium">
              Χρήστες και διορθώσεις αιτήσεων
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 bg-white dark:bg-jewel-bg p-1.5 rounded-2xl shadow-sm border border-gray-200 dark:border-jewel-border">
          <button
            onClick={() => setSubTab('users')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all duration-300 ${
              subTab === 'users'
                ? 'bg-blue-600 dark:bg-jewel-teal text-white shadow-md shadow-blue-100 dark:shadow-jewel-teal/30 scale-105'
                : 'text-gray-400 dark:text-jewel-text-muted hover:text-gray-600 dark:hover:text-jewel-text hover:bg-gray-50 dark:hover:bg-jewel-surface'
            }`}
          >
            <UserCog className="h-3.5 w-3.5" />
            Διαχείριση Χρηστών
          </button>
          <button
            onClick={() => setSubTab('leave-type')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all duration-300 ${
              subTab === 'leave-type'
                ? 'bg-orange-600 text-white shadow-md shadow-orange-100 dark:shadow-orange-900/40 scale-105'
                : 'text-gray-400 dark:text-jewel-text-muted hover:text-gray-600 dark:hover:text-jewel-text hover:bg-gray-50 dark:hover:bg-jewel-surface'
            }`}
          >
            <RefreshCw className="h-3.5 w-3.5" />
            Διόρθωση Τύπου Άδειας
          </button>
        </div>
      </div>

      <div className="relative">
        {subTab === 'users' ? (
          <UserManagementView
            currentUser={currentUser}
            departments={departments}
            onReloadUsers={onReloadUsers}
          />
        ) : (
          <LeaveTypeCorrectionView holidays={holidays} />
        )}
      </div>
    </div>
  );
};

export default AdminToolsView;
